"use client";

import Box from "@mui/material/Box";
import Link from "next/link";
import { FunnelButton } from "../../FunnelButton";
import { CallDetailsCard } from "./CallDetailsCard";
import { IndustryExploreLink } from "./IndustryExploreLink";
import { QueueHeadline } from "./QueueHeadline";
import type { VocationIndustry } from "@portal/app/_common/types/vocationIndustry";

interface DefaultScreenProps {
  title: string;
  body: string;
  isBodyMarkdown: boolean;
  industry?: VocationIndustry;
  /** Primary CTA from CMS overrides; when present, renders as the primary button. */
  primaryCta?: { text: string; href: string };
}

export const DefaultScreen = ({
  title,
  body,
  isBodyMarkdown,
  industry,
  primaryCta,
}: DefaultScreenProps) => (
  <>
    <QueueHeadline title={title} body={body} isMarkdown={isBodyMarkdown} />
    <CallDetailsCard />
    {primaryCta && (
      <Box sx={{ mt: 1 }}>
        <Link href={primaryCta.href} passHref legacyBehavior>
          <FunnelButton component="a" data-testid="success-cta">
            {primaryCta.text}
          </FunnelButton>
        </Link>
      </Box>
    )}
    <IndustryExploreLink industry={industry} />
  </>
);
